var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "EXDialog",
    {
      attrs: {
        title: _vm.title,
        label: _vm.label,
        showVisible: _vm.curShowChoose,
        width: "70%"
      },
      on: { close: _vm.closeFn }
    },
    [
      _c("div", { staticStyle: { display: "flex", height: "90%" } }, [
        _c("div", { staticClass: "left-tree" }, [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    width: "0.8rem",
                    "margin-right": "0.1rem",
                    "text-align": "right"
                  }
                },
                [_vm._v(_vm._s(_vm.label) + " :")]
              ),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  "suffix-icon": "el-icon-search",
                  placeholder: "可根据关键词过滤"
                },
                model: {
                  value: _vm.keyWords,
                  callback: function($$v) {
                    _vm.keyWords = $$v
                  },
                  expression: "keyWords"
                }
              }),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: {
                    "min-width": ".8rem",
                    "margin-left": "0.1rem"
                  },
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.resetKeyword }
                },
                [_vm._v("重置")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "100%", height: "calc(100% - 30px)" } },
            [
              _c("ETree", {
                ref: "fatherTree",
                attrs: {
                  treeList: _vm.treeList,
                  ifEditMenu: false,
                  nodeWidth: "100%",
                  treeHeight: "100%"
                },
                on: { fetchTableData: _vm.clickNode }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right-trans" },
          [
            _c("div", { staticClass: "checked-per" }, [
              _vm._v("已选人员：" + _vm._s(_vm.checkedPerson))
            ]),
            _vm._v(" "),
            _c("el-transfer", {
              attrs: {
                filterable: "",
                "filter-placeholder": "请输入人员名单",
                titles: ["待选", "已选"],
                props: _vm.defaultProps,
                data: _vm.personList
              },
              on: { change: _vm.choosePerson },
              model: {
                value: _vm.checkedKey,
                callback: function($$v) {
                  _vm.checkedKey = $$v
                },
                expression: "checkedKey"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "medium" },
              on: { click: _vm.sureFn }
            },
            [_vm._v("确定")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "medium", plain: "" },
              on: { click: _vm.closeFn }
            },
            [_vm._v("取消")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42425300", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42425300","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXDialog/EXChoosePerson.vue
// module id = 430
// module chunks = 0